import { render, staticRenderFns } from "./ModalEventChanges.vue?vue&type=template&id=23b2484c&scoped=true&"
import script from "./ModalEventChanges.vue?vue&type=script&lang=js&"
export * from "./ModalEventChanges.vue?vue&type=script&lang=js&"
import style0 from "./ModalEventChanges.vue?vue&type=style&index=0&id=23b2484c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b2484c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b2484c')) {
      api.createRecord('23b2484c', component.options)
    } else {
      api.reload('23b2484c', component.options)
    }
    module.hot.accept("./ModalEventChanges.vue?vue&type=template&id=23b2484c&scoped=true&", function () {
      api.rerender('23b2484c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ModalEventChanges.vue"
export default component.exports